<template>
    <div class="header-apr">
      <b-tabs v-model="tabIndex">
            <b-tab :title="'Autorizações'" justified>
            <template slot="title">
              <div style="width: fit-content; display: flex; flex-direction: row; align-items: center; justify-content: center;">
                <i class="fa fa-bars text-third"></i><span class="d-md-down-none pl-1 text-third"> Cabeçalho</span>
              </div>
            </template>
            <headingQma v-if="tabIndex === 0" ref="headingQma" :propQma="propQma" :qma="qma"></headingQma>
           </b-tab>
           <b-tab :title="'Autorizações'" justified>
            <template slot="title">
              <div style="width: fit-content; display: flex; flex-direction: row; align-items: center; justify-content: center;">
                <i class="fa fa-book text-third"></i><span class="d-md-down-none pl-1 text-third"> Detalhes</span>
              </div>
            </template>
            <detailsQma v-if="tabIndex === 1" ref="DetailsQma" :propQma="propQma" :qma="qma"></detailsQma>
           </b-tab>
           <b-tab :title="'Autorizações'"  v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
            <template slot="title" >
              <div style="width: fit-content; display: flex; flex-direction: row; align-items: center; justify-content: center;">
                <i class="fa fa-tv" style="color:#008148"></i><span class="d-md-down-none pl-1 text-third"> Mídias</span>
              </div>
            </template>
            <mediasQma  v-if="tabIndex === 2" ref="midias" :propQma="propQma" :qma="qma" :idQma="idQma"></mediasQma>
           </b-tab>
           <b-tab :title="'Autorizações'" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
            <template slot="title">
              <div style="width: fit-content; display: flex; flex-direction: row; align-items: center; justify-content: center;">
                <i class="fa fa-signature" style="color:#008148"></i><span class="d-md-down-none pl-1 text-third">Assinaturas</span>
              </div>
            </template>
            <signatureQma v-if="tabIndex === 3" ref="signatureQma" :propQma="propQma" :qma="qma"></signatureQma>
           </b-tab>
           <b-tab :title="'Autorizações'" v-if="hasRole(roles.QMA_SEARCH_CONTROLLER_APPROVAL)">
            <template slot="title">
              <div style="width: fit-content; display: flex; flex-direction: row; align-items: center; justify-content: center;">
                <i class="fa fa-history" style="color:#008148"></i><span class="d-md-down-none pl-1 text-third">Histórico</span>
              </div>
            </template>
            <logQma v-if="tabIndex === 4" ref="logQma" :propQma="propQma" :qma="qma"></logQma>
           </b-tab>
      </b-tabs>
    </div>
</template>

<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import headingQma from '@/views/private/qma/inqueryQma/components/details/headingQma/headingQma.vue'
import detailsQma from '@/views/private/qma/inqueryQma/components/details/detailsQma/detailsQma'
import mediasQma from '@/views/private/qma/inqueryQma/components/details/mediasQma/mediasQma'
import signatureQma from '@/views/private/qma/inqueryQma/components/details/signatureQma/signatureQma'
import logQma from '@/views/private/qma/inqueryQma/components/details/logQma/logQma'

export default {
  name: 'inqueryDetailsTableQma',
  mixins: [ActionsForm],
  components: {HeadDetailsGama, detailsQma, mediasQma, signatureQma, logQma, headingQma},
  data () {
    return {
      tabIndex: 0,
      qmaMemory: []
    }
  },
  props: ['propQma', 'qma', 'idQma'],

  watch: {
    // tabIndex: function (newValue) {
    //   if (newValue === 0) {
    //     this.$refs.DetailsQma.onLoad(this.propQma)
    //   }
    //   if (newValue === 1) {
    //     this.$refs.midias.onLoad(this.qmaMemory)
    //   }
    //   if (newValue === 2) {
    //     this.$refs['signatureQma'].onLoad()
    //   }
    // }
  },

  mounted () {
  },
  methods: {
    onLoad (value) {
      if (this.tabIndex === 0) {
        this.$refs.headingQma.onLoad(value)
      }
      if (this.tabIndex === 1) {
        this.$refs.DetailsQma.onLoad(value)
      }
      if (this.tabIndex === 2) {
        this.$refs.midias.onLoad(value)
      }
      if (this.tabIndex === 3) {
        this.$refs.signatureQma.onLoad(value)
      }
      if (this.tabIndex === 4) {
        this.$refs.logQma.onLoad(value)
      }
      this.qmaMemory = value
    }
  }
}

</script>

<style scoped>
.header-apr {
    background-color: white;
    height: 100%;
}
#impor-ex-price{
display: none;
}
.novoTemplate {
    padding: 0.5rem 3rem 0.5rem 3rem
}
.descricaoArea{
    width: 100%;
    height: 5rem;
    border-color: #b3b3b3;
    border-radius: 1px;
}
.header-title{
color: white;
font-weight: bold;
font-size: 16px;
font-family: 'Segoe UI';
}
.btn-generate-lote {
    height: 2rem;
    padding: 0 1rem;
    background: #008144;
    color: white;
    border-radius: 4px;
    border: none;
    font-size: 12px;
}
.btn-generate-lote:hover{
    background: #024d2a;
}
.button-cancel,
.button-save{
margin-top: 10;
font-size: 12PX;
outline: transparent;
border: transparent;
border-radius: 4px;
text-transform: uppercase;
width: 190px;
height: 40px;
}

.container_cancel_save{
justify-content: center;
width: 100%;
margin-top: 1.5rem;
column-gap: 10px;
}

.button-cancel{
background-color: #b60000;
color: white;
}
.button-save{
background-color: darkgreen;
color: white;
}
</style>



// WEBPACK FOOTER //
// src/views/private/qma/inqueryQma/inqueryQmaPivs/components/inqueryQmaPivsTable/components/inqueryQmaPivsDetails/components/inqueryDetailsTableQma/inqueryDetailsTableQmaPivs.vue